export default {
    props: {
        connectionDefaultsContentColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.content.color'
        }, 
        connectionDefaultsContentFontFamily: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.content.fontFamily'
        }, 
        connectionDefaultsContentFontSize: {
            type: Number,
            default: undefined,
            kComposite: 'connectionDefaults.content.fontSize'
        }, 
        connectionDefaultsContentFontStyle: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.content.fontStyle'
        }, 
        connectionDefaultsContentFontWeight: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.content.fontWeight'
        }, 
        connectionDefaultsContentTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'connectionDefaults.content.template'
        }, 
        connectionDefaultsContentText: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.content.text'
        }, 
        connectionDefaultsContentVisual: {
            type: Function,
            default: undefined,
            kComposite: 'connectionDefaults.content.visual'
        }, 
        connectionDefaultsEditable: {
            type: Boolean,
            default: undefined,
            kComposite: 'connectionDefaults.editable'
        }, 
        connectionDefaultsEditableDrag: {
            type: Boolean,
            default: undefined,
            kComposite: 'connectionDefaults.editable.drag'
        }, 
        connectionDefaultsEditableRemove: {
            type: Boolean,
            default: undefined,
            kComposite: 'connectionDefaults.editable.remove'
        }, 
        connectionDefaultsEditableTools: {
            type: Array,
            default: undefined,
            kComposite: 'connectionDefaults.editable.tools'
        },         connectionDefaultsEndCap: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.endCap'
        }, 
        connectionDefaultsEndCapFill: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.endCap.fill'
        }, 
        connectionDefaultsEndCapFillColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.endCap.fill.color'
        }, 
        connectionDefaultsEndCapStroke: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.endCap.stroke'
        }, 
        connectionDefaultsEndCapStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.endCap.stroke.color'
        }, 
        connectionDefaultsEndCapStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.endCap.stroke.dashType'
        }, 
        connectionDefaultsEndCapStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectionDefaults.endCap.stroke.width'
        }, 
        connectionDefaultsEndCapType: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.endCap.type'
        }, 
        connectionDefaultsFromConnector: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.fromConnector'
        }, 
        connectionDefaultsHoverStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.hover.stroke.color'
        }, 
        connectionDefaultsSelectable: {
            type: Boolean,
            default: undefined,
            kComposite: 'connectionDefaults.selectable'
        }, 
        connectionDefaultsSelectionHandlesFill: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.selection.handles.fill'
        }, 
        connectionDefaultsSelectionHandlesFillColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.selection.handles.fill.color'
        }, 
        connectionDefaultsSelectionHandlesStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.selection.handles.stroke.color'
        }, 
        connectionDefaultsSelectionHandlesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectionDefaults.selection.handles.width'
        }, 
        connectionDefaultsSelectionHandlesHeight: {
            type: Number,
            default: undefined,
            kComposite: 'connectionDefaults.selection.handles.height'
        }, 
        connectionDefaultsStartCap: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.startCap'
        }, 
        connectionDefaultsStartCapFill: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.startCap.fill'
        }, 
        connectionDefaultsStartCapFillColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.startCap.fill.color'
        }, 
        connectionDefaultsStartCapStroke: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.startCap.stroke'
        }, 
        connectionDefaultsStartCapStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.startCap.stroke.color'
        }, 
        connectionDefaultsStartCapStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.startCap.stroke.dashType'
        }, 
        connectionDefaultsStartCapStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectionDefaults.startCap.stroke.width'
        }, 
        connectionDefaultsStartCapType: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.startCap.type'
        }, 
        connectionDefaultsStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.stroke.color'
        }, 
        connectionDefaultsStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectionDefaults.stroke.width'
        }, 
        connectionDefaultsToConnector: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.toConnector'
        }, 
        connectionDefaultsType: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.type'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-diagram-vue-wrapper/src/KendoDiagram/ConnectionDefaults.js